<!-- Contact Us Page -->
<div class="contact-us-container">
  <!-- Left Section - Contact Information -->
  <div class="contact-info-section">
    <div class="contact-info-card">
      <!-- Head Office Address -->
      <div class="contact-item">
        <div class="contact-icon">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
          </svg>
        </div>
        <div class="contact-details">
          <h3 class="contact-title">Head Office Address:</h3>
          <p class="contact-text">Mira Road (E), Thane, Maharashtra, India</p>
        </div>
      </div>

      <div class="contact-divider"></div>

      <!-- Branch Office Address -->
      <div class="contact-item">
        <div class="contact-icon">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
          </svg>
        </div>
        <div class="contact-details">
          <h3 class="contact-title">Branch Office Address:</h3>
          <p class="contact-text">Chennai, Tamil Nadu, India</p>
          <p class="contact-text">+914442624172</p>
        </div>
      </div>

      <div class="contact-divider"></div>

      <!-- European Sales Office -->
      <div class="contact-item">
        <div class="contact-icon">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
          </svg>
        </div>
        <div class="contact-details">
          <h3 class="contact-title">European Sales Office</h3>
          <p class="contact-text">(Sweden) Uppsala, Sweden</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Section - Contact Form -->
  <div class="contact-form-section">
    <div class="form-header">
      <div class="form-subtitle">
        <div class="subtitle-line"></div>
        <span>GET IN TOUCH</span>
      </div>
      <h2 class="form-title">Write Us Something</h2>
    </div>

    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
      <!-- Name and Email Row -->
      <div class="form-row">
        <div class="form-group">
          <input 
            type="text" 
            formControlName="name" 
            placeholder="Your Name"
            class="form-input"
          >
        </div>
        <div class="form-group">
          <input 
            type="email" 
            formControlName="email" 
            placeholder="Your Email"
            class="form-input"
          >
        </div>
      </div>

      <!-- Phone and Service Row -->
      <div class="form-row">
        <div class="form-group">
          <input 
            type="tel" 
            formControlName="phone" 
            placeholder="Phone"
            class="form-input"
          >
        </div>
        <div class="form-group">
          <select formControlName="service" class="form-select">
            <option value="" disabled selected>Select Service</option>
            <option value="consulting">Consulting</option>
            <option value="development">Development</option>
            <option value="design">Design</option>
            <option value="support">Support</option>
            <option value="other">Other</option>
          </select>
        </div>
      </div>

      <!-- Message Row -->
      <div class="form-row">
        <div class="form-group full-width">
          <textarea 
            formControlName="message" 
            placeholder="Write Message"
            rows="6"
            class="form-textarea"
          ></textarea>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="form-row">
        <div class="form-group full-width">
          <button type="submit" class="submit-btn" [disabled]="!contactForm.valid || isSubmitting">
            <span>SEND MESSAGE</span>
            <svg class="w-5 h-5 ml-2" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path>
            </svg>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
